import React from 'react'
import { PortfolioProject } from './SectionPortfolio'
import './PortfolioProjectOverview.css'
import YoutubeEmbed from '../../Misc/YoutubeEmbed';

interface Props {
    project?: PortfolioProject;
}

const lineBreakChar = "\n";

const PortfolioProjectOverview: React.FC<Props> = ({ project }) => {
    return (
        <div>
            {project &&
                <div className="mb-5">
                    {project.youtubeId
                        ? <YoutubeEmbed embedId={project.youtubeId}></YoutubeEmbed>
                        : <img className="banner-img mb-3" src={require(`../../../images/banners/${project.bannerImgName}`).default} />
                    }
                    <h4 className="header">{project.name}</h4>

                    {project.description.split(lineBreakChar).map((text) => {
                        return (
                            <div className="mb-2">
                                <span>{text} <br /> </span>
                            </div>
                        )
                    })}

                    <h4 className="mt-4 header">Responsibilities</h4>
                    <ul>
                        {/* TODO: Figure out nested responsibilities */}
                        {project.responsibilities.map((responsibility) => {
                            return <li>{responsibility}</li>
                        })}
                    </ul>

                    <h4 className="mt-4 header">Links</h4>
                    {project.links?.map((tuple: [name: string, link: string]) => {
                        return (
                            <div>
                                <a href={tuple[1]} target="_blank">{tuple[0]}</a>
                                <br />
                            </div>
                        )
                    })}
                </div>
            }
        </div>

    )
}

export default PortfolioProjectOverview
